import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "field", "queue", "match"]
  static values = {url: String}

  reorder(e) {
    const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;

    fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        ordered_ids: this.matchTargets.map(match => match.dataset.matchId),
      })
    })
  }
}
